import { isNil } from 'lodash'
import { ChangeEvent, useState } from 'react'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { TOGGLE_FILTERING_RULE } from './api/mutation'
import { useSnackbar } from './useSnackbar'

import type { UseToggleFilteringRule, UseToggleFilteringRuleProps } from './types'
import type { ToggleFilteringRuleMutation, ToggleFilteringRuleMutationVariables } from 'gql/graphql'

export const useToggleFilteringRule = ({
  enabled,
  id,
  name,
}: UseToggleFilteringRuleProps): UseToggleFilteringRule => {
  const { snackbar } = useSnackbar(name)
  const [checked, setChecked] = useState<boolean>(enabled)

  const { mutateAsync } = useMutation<
    ToggleFilteringRuleMutationVariables,
    ToggleFilteringRuleMutation
  >({
    mutation: TOGGLE_FILTERING_RULE,
  })

  const update = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
    const value: boolean = event.target.checked

    const variables = { input: { enabled: value, id } }
    const result = await mutateAsync(variables)

    if (result === undefined) {
      return
    }

    const responseErrorsLength: number | undefined = result.errors?.length
    const mutationErrorsLength: number | undefined = result.data.toggleFilteringRule?.errors?.length

    if (isNil(responseErrorsLength) && isNil(mutationErrorsLength)) {
      setChecked(value)
      snackbar(value)
    } else {
      snackbar(value, 'error')
    }
  }

  return {
    checked,
    update,
  }
}
